import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-register-end',
  templateUrl: './register-end.component.html',
  styleUrls: ['./register-end.component.css']
})
export class RegisterEndComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  redirectToLogin() {
    this.router.navigate(['auth'])
    .then(() => {
        window.location.reload();
    });
  }

}
